"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPELL_CHECK_WORDS = void 0;
exports.SPELL_CHECK_WORDS = ['idk', 'neurone', 'neurones'];
//# sourceMappingURL=spell-check-words.js.map